import React from 'react'

const Contact = () => {
  return (
        <main style={{ 
      maxWidth: '800px', 
      margin: '0 auto', 
      padding: '40px 20px',
      textAlign: 'center'
    }}>
      <h1 className="about-title" style={{ marginBottom: '40px' }}>Contact:</h1>

      <section style={{ 
        marginBottom: '40px',
        paddingBottom: '40px',
        borderBottom: '1px solid #ddd'
      }}>
        
        
          <p>
  Email: <a href="mailto:milotpeterson@gmail.com">milotpeterson@gmail.com</a>
</p>

        
        </section>
    </main>
  )
}

export default Contact